<template>
  <Paper class="newQuota">
    <searchTenant @closeChange="searchCode" ref="search" :searchBlock='searchBlock' class="quota-config-search"></searchTenant>
   <div class="quota-config-table">
        <quotaTable :tableData="tableData" @stateChange="stateCode" @changePush="changeCode" @deleteRow="deleteRow"></quotaTable>
   </div>
   <div class="newQuota-add">
        <el-button @click="newCode" icon="el-icon-plus" type="primary" size="mini" class="new-button">
            {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
        </el-button>
   </div>
    <pageList v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="quota-config-page"></pageList>

    <el-dialog
    customClass="customWidth"
      :title="$translate('lang.E3202103120006', { defaultText: '限额配置新增修改' })"
      :visible.sync="dialogVisible"
      :before-close="cancelCheck"
      width="680px"
    >
      <new-quota :templateList="templateList" ref="ch" :tenantList="tenantList"></new-quota>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCheck" class="system-management-cancel-button" size="mini">
            {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
        </el-button>
        <el-button type="primary" @click="sendReq" class="system-management-confirm-button" size="mini" :loading="saveBlock">
            {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
        </el-button>
      </div>
    </el-dialog>
  </Paper>
</template>
<script>
import searchTenant from '../../../components/systemComponent/newSearch';
import Paper from '@/components/core/paper/Paper';
import quotaTable from './table';
import newQuota from './newQuota/Index';
import pageList from '../../../components/systemComponent/pageList';
import {
    getQuota,
    changeQuotaState,
    changeQuota,
    tenantList,
    deleteQuota
} from '../../../api/systemManagementApi';
export default {
    name: 'quota',
    data() {
        return {
            pageState: true,
            searchBlock: false,
            saveBlock: false,
            tenantList: [],
            showClo: false,
            dialogVisible: false,
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            tableData: [],
            templateList: {
                id: '',
                version: '',
                deleteFlag: true,
                tenantCode: '',
                tenantName: '',
                maxIdentityAmount: '',
                maxLogAmount: '',
                maxTotalFileSize: '',
                maxDailyParsingAmount: '',
                maxDailyRegistingAmount: ''
            }
        };
    },
    methods: {
        sendReq() {
            this.$refs.ch.$refs.newTemplateList.validate(valid => {
                if (valid) {
                    const changeData = this.$refs.ch.templateList;
                    this.saveBlock = true;
                    if (!changeData.maxLogAmount) {
                        changeData.maxLogAmount = 1;
                    }
                    changeQuota({
                        id: changeData.id,
                        maxIdentityAmount: changeData.maxIdentityAmount,
                        maxLogAmount: changeData.maxLogAmount,
                        maxTotalFileSize: changeData.maxTotalFileSize,
                        maxDailyParsingAmount: changeData.maxDailyParsingAmount,
                        maxDailyRegistingAmount: changeData.maxDailyRegistingAmount,
                        tenantCode: changeData.tenantCode,
                        version: changeData.version
                    }).then(res => {
                        if (+res.code === 0) {
                            this.dialogVisible = false;
                            this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                            this.getInf();
                            Object.assign(this.$data.templateList, this.$options.data().templateList);
                            this.$nextTick(() => {
                                this.$refs.ch.$refs.newTemplateList.clearValidate();
                            });
                        }
                        this.saveBlock = false;
                    }).catch(() => {
                        this.saveBlock = false;
                    });
                } else {
                }
            });
        },
        searchCode(value) {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.getInf();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        newCode() {
            this.dialogVisible = true;
        },
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.getInf();
        },
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.getInf();
        },
        stateCode(value) {
            if (value.state === 0) {
                changeQuotaState({
                    id: value.id,
                    avail: true,
                    version: value.version
                }).then(res => {
                    this.$message.success(this.$translate('lang.E3202103100020', { defaultText: '启用成功' }));
                    this.getInf();
                });
            } else {
                changeQuotaState({
                    id: value.id,
                    avail: false,
                    version: value.version
                }).then(res => {
                    this.$message.success(this.$translate('lang.E3202103100021', { defaultText: '禁用成功' }));
                    this.getInf();
                });
            }
        },
        changeCode(value) {
            this.tenantList.map(item => {
                if (item.tenantCode === value.tenantCode) {
                    value.tenantName = item.tenantName;
                }
            });
            Object.keys(this.templateList).forEach(key => {
                this.templateList[key] = value[key];
            });
            this.dialogVisible = true;
        },
        deleteRow(row) {
            if (!row || !row.id) {
                return;
            }
            this.$confirm(this.$translate('lang.E3202112170001', { defaultText: '是否删除该条数据？' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' })
                }).then(() => {
                deleteQuota(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功' }));
                        this.getInf();
                    }
                });
            });
        },
        // 初始获取数据
        getInf() {
            getQuota({
                tenantCodeCondi: this.$refs.search.queries.tenantCode,
                tenantName: this.$refs.search.queries.tenantName,
                state: this.$refs.search.queries.status,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize
            }).then(res => {
                this.tableData = res.data.list;
                this.pageMenu.totalCount = res.data.totalCount;
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        // 取消非空验证
        cancelCheck() {
            Object.assign(this.$data.templateList, this.$options.data().templateList);
            this.$nextTick(() => {
                this.$refs.ch.$refs.newTemplateList.clearValidate();
            });
            this.dialogVisible = false;
        }
    },
    components: {
        newQuota,
        Paper,
        pageList,
        searchTenant,
        quotaTable
    },
    created() {
        tenantList(1).then(res => {
            this.tenantList = res.data;
        });
    },
    mounted() {
        this.getInf();
    }
};
</script>
<style lang="less">
.newQuota{
    .quota-config-table{
        .el-table {
        height: calc(100vh - 180px) !important;
    }
    .row-bg {
        margin-top: 20px;
    }
    }
    .quota-config-page{
        text-align: right;
        margin-top: 20px;
    }
    .customWidth{
        width:672px;
    }
    .newQuota .el-dialog__body {
    padding-left: 0;
    }
    .newQuota-add{
        float: left;
        margin-top: 20px;
    }
 // 对话框取消按钮
    // .system-management-cancel-button{
    //     width: 88px;
    //     height: 32px;
    //     border: 1px solid #D9D9D9;
    // }
    // 对话框确定按钮
    // .system-management-confirm-button{
    //     width: 88px;
    //     height: 32px;
    //     background: #2BDBDC;
    //     border: 1px solid #2BDBDC;
    // }
    .el-form-item__label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

</style>